import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const restoreLogo: (
  fetchContext: FetchContext,
  questionnaireId: number,
  accessToken?: string) => Promise<void> = (fetchContext, questionnaireId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/logo/restoration`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'restore logo'));
